import { getConfig } from '../config';

const prefix = () => getConfig()?.pushPathPrefix || '/n1';

export const PUSH_PATHS = {
    hybridTournamentOverview: tournamentId => `${prefix()}/hybrid/overview/${tournamentId}/`,
    channelStatus: () => `${prefix()}/status/`,
    matches: () => `${prefix()}/live/matches/`,
    sportMenu: () => `${prefix()}/overview/sports/`,
    sportOverviewMarkets: sportCode => `${prefix()}/overview/${sportCode}/markets/`,
    sportOverviewTournament: (sportCode, tournamentId) =>
        `${prefix()}/overview/${sportCode}/tournament/${tournamentId}/`,
    sportOverviewMatch: (sportCode, matchId) => `${prefix()}/overview/${sportCode}/match/${matchId}/`,
    sportOverview: sportCode => `${prefix()}/overview/${sportCode}/tournaments/`,
    sportOverviewBets: (sportCode, marketId) => `${prefix()}/overview/${sportCode}/bets/${marketId}/`,
    sportOverviewBetsMatch: (sportCode, matchId, marketId) =>
        `${prefix()}/overview/${sportCode}/bets-match/${matchId}/${marketId}/`,
    sportOverviewBetsTournament: (sportCode, tournamentId, marketId) =>
        `${prefix()}/overview/${sportCode}/bets-tournament/${tournamentId}/${marketId}/`,
    matchDetailBets: (matchId, channel) => `${prefix()}/match/${matchId}/bets/${channel}/`,
    matchDetailCategoryBets: (matchId, marketCategoryId, channel) =>
        `${prefix()}/match/${matchId}/bets/${marketCategoryId}/${channel}/`,
    matchDetailCategories: matchId => `${prefix()}/match/${matchId}/markets/`,
    matchMbm: matchId => `${prefix()}/match/${matchId}/mbm/`,
    matchScoreboard: matchId => `${prefix()}/match/${matchId}/scoreboard/`,
    betInfo: betId => `${prefix()}/bet/${betId}/`
};
